import { Box, Button, Card, Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

const PlanBillingComponent = ({ expiresOn, currency_symbol, totalAmount, newExpiresOn, handlePaymentDialog }) => {
  const { t: translate } = useTranslation();
  return (
    <Card sx={{ p: 3, maxWidth: 400, width: '100%', mt: 1, flex: 1 }}>
      <Box>
        <Stack sx={{ width: '100%', alignItems: 'center' }}>
          <Typography color="text.secondary">{translate('billing.subscription_info.plan_expires_on')}</Typography>
          <Typography variant="overline" display="block" sx={{ mb: 1.5 }}>
            {CommonHelper.formateDateWithYear(expiresOn)}
          </Typography>
          <Typography color="text.secondary">{translate('billing.subscription_info.new_plan_begins_from')}</Typography>
          <Typography variant="overline" display="block">
            {CommonHelper.formateDateWithYear(expiresOn)}
          </Typography>
          <Typography color="text.secondary">{translate('common.to')}</Typography>
          <Typography variant="overline" display="block" sx={{ mb: 1.5 }}>
            {CommonHelper.formateDateWithYear(newExpiresOn)}
          </Typography>
          <Divider />
          <Stack alignItems="center" sx={{ mb: 1.5 }}>
            <Typography variant="h5">
              {translate('common.total')} = {currency_symbol}
              {totalAmount}
            </Typography>
          </Stack>
          <Divider />
          <Button
            fullWidth
            size="large"
            variant="contained"
            sx={{ margin: '15px' }}
            onClick={() => handlePaymentDialog(true)}
          >
            {translate('common.proceed')}
          </Button>
        </Stack>
      </Box>
    </Card>
  );
};
export default PlanBillingComponent;
